// extracted by mini-css-extract-plugin
export default {"srOnly":"Nni6XO","postCount":"lTgIKs"};